import React from "react";
import LoginPage from "../components/auth/LoginPage";
import EmptyLayout from "../components/layouts/EmptyLayout";

export default function Login({ location }) {
    return <EmptyLayout className="w-full min-h-[100vh] flex items-center justify-center bg-secondary">
        <LoginPage location={location} />
    </EmptyLayout>
}
